import React, { ReactNode, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { backOnboardingStateAction } from 'Shared/actions/onboardingState';
import CharmaLogo from 'Shared/components/Logos/CharmaLogo';
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';

import { OnboardingWizardStep } from '../../../types';
import StepsSection from './StepsSection/StepsSection';
import './PageWrapper.scss';

type Props = {
  children: ReactNode;
};

function PageWrapper({ children }: Props) {
  const dispatch = useDispatch();
  const step: OnboardingWizardStep = useSelector(state => state.onboardingState.step);

  const handleBackClick = useCallback(() => dispatch(backOnboardingStateAction()), [dispatch]);

  return (
    <div className="p-4 pb-5 d-flex flex-column vh-100">
      {step !== OnboardingWizardStep.scheduleDemo && <StepsSection />}
      <div className="pt-2 mb-4 d-flex" style={{ marginLeft: '-.5rem' }}>
        {![OnboardingWizardStep.profile, OnboardingWizardStep.scheduleDemo].includes(step) && (
          <WpButton variant="tertiary" onClick={handleBackClick}>
            <WpIcon name="chevron-left" />
            Back
          </WpButton>
        )}
        <div className="ml-auto">
          <CharmaLogo width="110" />
        </div>
      </div>
      <div className="pt-4">{children}</div>
    </div>
  );
}

export default PageWrapper;
